/*
 * File Created: Wednesday, 28th December 2022 12:51:24 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2022 Addble Solutions Private Limited. All Rights Reserved.
 */
import { Colors } from "./constants/color";
import {
  Discord,
  Facebook,
  Instagram,
  LinkedIn,
  Pinterest,
  Slack,
  Twitter,
  Whatsapp,
  Youtube,
} from './constants/icons';
// import { Links } from './types/links/links.type';

interface Icon {
  id: string | null;
  icon: JSX.Element;
  name: string;
  color: string;
}

// const MediaIcon = (links: Links): Icon[] => {
export const Icons: Icon[] = [
    {
      id: '1',
      icon: <Facebook />,
      name: "Facebook",
      color: Colors.chambray,
    },
    {
      id: '2',
      icon: <Discord />,
      name: "Discord",
      color: Colors.chetwode_blue,
    },
    {
      id: '3',
      icon: <Instagram />,
      name: "Instagram",
      color: Colors.cerise,
    },
    {
      id: '4',
      icon: <LinkedIn />,
      name: "LinkedIn",
      color: Colors.science_blue,
    },
    {
      id: '5',
      icon: <Pinterest />,
      name: "Pinterest",
      color: Colors.monza,
    },
    {
      id: '6',
      icon: <Twitter />,
      name: "Twitter",
      color: Colors.seagull,
    },
    {
      id: '7',
      icon: <Whatsapp />,
      name: "Whatsapp",
      color: Colors.deep_sea_green,
    },
    {
      id: '8',
      icon: <Youtube />,
      name: "Youtube",
      color:  Colors.punch,
    },
    {
      id: '9',
      icon: <Slack />,
      name: "Slack",
      color: Colors.fuel_yellow,
    },
  ];

  // return Icons;
  // .map((icon) => {
  //   return (
  //     <Box key={icon.id} sx={{ display: icon.name === undefined ? 'none' : 'block' }}>
  //       {icon.icon}
  //     </Box>
  //   );
  // });

  // return (
  // <>
  // <Discord/>
  // <Facebook/>
  // <Instagram/>
  // <LinkedIn/>
  // <Pinterest/>
  // <Slack/>
  // <Twitter/>
  // <Whatsapp/>
  // <Youtube/>
  // </>
  // )
// };

// export default MediaIcon;

/**
 * Adding social media to an jsx element
 *
 * get the data from the api
 *
 *
 */
